<template>
	<gc-dialog
		:title="formValues ? '编辑告警名称' : '新增告警名称'"
		:show.sync="visible"
		width="500px"
		:okLoading="requestLoading"
		@close="$emit('close-modal')"
		@cancel="$emit('close-modal')"
		@ok="handleSubmitForm"
	>
		<el-form :model="modelForm" :rules="rules" ref="modelForm" label-position="top">
			<el-form-item label="告警名称" prop="alarmName">
				<el-input size="small" v-model="modelForm.alarmName" placeholder="请输入告警名称" clearable></el-input>
			</el-form-item>
		</el-form>
	</gc-dialog>
</template>

<script>
import { apiCreateAlarmName, apiUpdateAlarmName } from '@/apis/alarm.api'
import { ruleRequired, ruleMaxLength } from '@/utils/rules'

export default {
	props: {
		formValues: {
			type: Object,
			default: () => null,
		},
	},
	data() {
		return {
			visible: true,
			modelForm: {
				alarmName: null,
			},
			rules: {
				alarmName: [ruleRequired('请输入告警名称'), ruleMaxLength(100)],
			},
			requestLoading: false,
		}
	},

	created() {
		this.updateFormValuesSet()
	},

	methods: {
		updateFormValuesSet() {
			if (this.formValues) {
				const { id, alarmName } = this.formValues
				Object.assign(this.modelForm, {
					id,
					alarmName,
				})
			}
		},

		handleSubmitForm() {
			this.$refs.modelForm.validate(async valid => {
				if (valid) {
					this.requestLoading = true
					try {
						const params = {
							alarmName: this.modelForm.alarmName,
							tenantId: this.$store.getters.userInfo.tenantId,
							...this.modelForm,
						}
						const API = this.formValues ? apiUpdateAlarmName : apiCreateAlarmName
						await API(params)
						this.$message.success('操作成功')
						this.$emit('close-modal', true)
					} finally {
						this.requestLoading = false
					}
				}
			})
		},
	},
}
</script>
